<template>
  <v-card flat>
    <v-card-text class="instructions-page content-500" v-if="$auth.watch.authenticated">
      <h2 class="page-title">Using The RoomReady App</h2>
      <div class="text-xs-left">
        <div class="instructions">
          <ol>
            <li>Please make sure you are using either Chrome or Safari (without incognito or private browsing mode)</li>
            <li>Select a campus, building and room</li>
            <li>Check that all room technology is functional</li>
            <li>Add notes to inoperable items, or those that required repair</li>
            <li>Submit your room report</li>
          </ol>
        </div>
        <div v-if="!!team && !!team.preRoundsInstructions" class="reminders">
          <p>{{ team.preRoundsInstructions }}</p>
        </div>
      </div>
      <div v-if="$auth.watch.authenticated" class="text-xs-center">
        <v-btn :to='"/" + teamId + "/room"' color='primary'>
          <v-icon left>forward</v-icon>
          <span class="btn__text">Start Rounds</span>
        </v-btn>
        <v-btn @click="logout()" flat color="error">
          <v-icon left>exit_to_app</v-icon>
          <span class="btn__text">Logout</span>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {}
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    team () {
      return this.$teamService.getTeam(this.teamId)
    }
  },
  methods: {
    start(){
      this.$router.push({name: 'RoomPicker', params: { teamId: this.teamId }});
    },
    logout() {
      this.$auth.logout();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TeamHome.vue